import React from 'react';
import { useCheckout } from './CheckoutContext';
export function WhatsIncluded() {
  const {
    openUpsell
  } = useCheckout();
  const items = ['Reprogramación mental', 'Identidad', 'Manifestación consciente', 'Autoestima', 'Relaciones', 'Dinero', 'Energía', 'Hábitos', 'Propósito', 'Acción alineada'];
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-2 leading-tight" data-id="element-176">
          ¿Qué incluye Realmanifestación?
        </h2>

        <p className="text-center text-sm sm:text-base text-brand-gray max-w-2xl mx-auto mb-5" data-id="element-177">
          Más de 200 protocolos, herramientas y ejercicios para transformar tu
          realidad desde adentro.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mb-5" data-id="element-178">
          <div className="order-2 lg:order-1" data-id="element-179">
            <img src="https://cdn.magicpatterns.com/uploads/he8gmTMdC2UcJ2rVNz4L4j/f1c93867-5d49-4857-b337-8bbad8fa489b.png" alt="Realmanifestación" className="w-full max-w-sm mx-auto" data-id="element-180" />
          </div>

          <div className="order-1 lg:order-2" data-id="element-181">
            <div className="grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-182">
              {items.map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-183">
                  <span className="text-brand-gold" data-id="element-184">✓</span>
                  <span data-id="element-185">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-186">
          <button onClick={openUpsell} className="bg-brand-gold text-brand-black px-8 py-3.5 rounded text-base sm:text-lg font-bold hover:opacity-90 transition-all hover:scale-[1.02]" data-id="element-187">
            QUIERO ACCESO AHORA
          </button>
        </div>
      </div>
    </section>;
}